import {IconButton} from "@material-ui/core";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {PublicationSearchResult, SearchContext} from "../../../types/common-search";
import Tooltip from "@material-ui/core/Tooltip";
import {InvalidateBatIcon} from "../../commons/icon/icons";
import {PublicationActionName} from "../../../types/workflow";
import {dispatchPublicationAction} from "../../../redux/actions/workflow.actions";
import CircularProgress from "@material-ui/core/CircularProgress";
import {uuidv4} from "../../../utils/uuid";
import {processInProgress} from "../../../redux/selectors/workflow.selectors";
import {PublicationStatus} from "../../../types/publication";
import Auth from "../../Auth";
import {ADMIN, PRODUCER} from "../../../utils/roles";
import ConfirmationDialog from "../../commons/ConfirmationDialog";


type Props = {
    publication: PublicationSearchResult
}

function CancelPrinterPdfPublication({publication}: Props) {
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const processInProgressSelector = useSelector(processInProgress)
    const [currentProcess, setCurrentProcess] = useState<string>();
    const [dialogOpen, openDialog] = useState(false);
    const closeDialog = () => openDialog(false)

    const displayLoading = () => {
        if (currentProcess && processInProgressSelector.includes(currentProcess)) {
            return <CircularProgress color="inherit" size={15} style={{marginTop: 15}}/>
        } else {
            return <IconButton style={{paddingLeft: "0px"}}
                               onClick={() => openDialog(true)}>
                <InvalidateBatIcon/>
            </IconButton>
        }
    }


    const cancelPrinterPdf = (publicationId: number) => {
        const uuid = uuidv4();

        dispatch(dispatchPublicationAction({
            id: publicationId,
            action: PublicationActionName.INVALIDATE_PUBLICATION_PRINTER_PDF,
            uuid,
            context: SearchContext.PUBLICATION
        }))
        setCurrentProcess(uuid)

    }

    if (publication.validationDate === null && publication.status === PublicationStatus.PUBLISHING && publication.lastPrinterPdfProcessStatus === "FINISHED") {
        return (
            <Auth requiredRoles={[ADMIN, PRODUCER]}>
                <ConfirmationDialog
                    title={t('workflows.pdf_annulation')}
                    description={''}
                    actions={[
                        {label: t('dialogs.cancel'), color: 'default'},
                        {
                            label: t('dialogs.confirm'), action: () => {
                                cancelPrinterPdf(publication.id)
                            }, variant: 'contained'
                        }
                    ]}
                    isOpened={dialogOpen}
                    onClose={closeDialog}
                />
                <Tooltip
                    title={t('workflows.cancel_pdf_printer') ?? ''}>
                    {displayLoading()}
                </Tooltip>
            </Auth>
        )
    } else {
        return (<></>)
    }

}

export default CancelPrinterPdfPublication;
